import { Image, LinkBase, Text } from '@belong/ui';
import clsx from 'clsx';
import { LIGHT_SOCIAL_PROOF_LOGOS } from '../../constants';
import css from './social-proof.module.css';

export function SocialProof({ regionName }: { regionName?: string }) {
  return (
    <div
      className={clsx(
        css.socialProof,
        'bg-dark-navy py-2xl mx-auto flex flex-col items-center rounded',
      )}
    >
      <div className={clsx(css.neonContainer, 'mb-2xl flex items-center')}>
        <div className={clsx(css.neonLines, 'mr-sm')} />
        <Text className={clsx(css.neonText, 'mr-sm')}>As Seen On</Text>
        <div className={clsx(css.neonLines)} />
      </div>
      <div className="mb-xl gap-y-xl grid w-full grid-cols-2 justify-around lg:grid-cols-3">
        {LIGHT_SOCIAL_PROOF_LOGOS.map(({ src, href }) => {
          const logoHRef = href(regionName ?? '');

          if (!logoHRef) {
            return null;
          }

          return (
            <div key={src} className="flex w-full justify-center">
              <LinkBase
                href={logoHRef}
                target="_blank"
                className={css.logoContainer}
              >
                <Image src={src} alt="" />
              </LinkBase>
            </div>
          );
        })}
      </div>
      <div className="gap-y-xl grid w-full grid-cols-1 lg:grid-cols-3">
        <LinkBase
          href="https://www.zillow.com/profile/BelongHome"
          target="_blank"
          className="flex w-full flex-col items-center"
        >
          <>
            <div className={css.starsContainer}>
              <Image src="/icons/almost-5-stars.svg" alt="" />
            </div>
            <Text
              variant="h3"
              fontWeight="semibold"
              className="mt-xs text-white"
            >
              Zillow
            </Text>
          </>
        </LinkBase>
        <LinkBase
          href="https://apps.apple.com/us/app/belong/id1607471774"
          target="_blank"
          className="flex w-full flex-col items-center"
        >
          <>
            <div className={css.starsContainer}>
              <Image src="/icons/almost-5-stars.svg" alt="" />
            </div>
            <Text
              variant="h3"
              fontWeight="semibold"
              className="mt-xs text-white"
            >
              App Store
            </Text>
          </>
        </LinkBase>
        <LinkBase
          href="https://www.thumbtack.com/ca/los-angeles/property-management/belong/service/375507726479204354"
          target="_blank"
          className="flex w-full flex-col items-center"
        >
          <>
            <div className={css.starsContainer}>
              <Image src="/icons/almost-5-stars.svg" alt="" />
            </div>
            <Text
              variant="h3"
              fontWeight="semibold"
              className="mt-xs text-white"
            >
              Thumbtack
            </Text>
          </>
        </LinkBase>
      </div>
    </div>
  );
}
